import DescriptionText from 'elements/DescriptionText';
import ds from 'designsystem';
import { media } from 'designsystem/index';

const Description = DescriptionText.extend`
  margin: 0;
  padding: ${ds.get('metrics.xs')} ${ds.get('metrics.s')};
  font-size: ${ds.fontSize('m')};
  line-height: ${ds.get('type.lineHeight.base')};
  font-weight: ${ds.get('type.fontWeight.regular')};
  
  ${media.tablet`
    width: 100%;
    padding: ${ds.get('metrics.xs')} ${ds.get('metrics.s')};
    font-size: ${ds.fontSize('l')};
    line-height: ${ds.get('type.lineHeight.l')};
  `}
`;

export default Description;



// WEBPACK FOOTER //
// ./src/kentico-blocks/LinkBanner/Description.jsx